import { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router";

import { useSelector } from "../../store";
import {
  fetchFirestoreDocument,
  fetchFirestoreCollection,
} from "../../utility/firebase";

import type {
  Ticket,
  Refference,
  AdminDoc,
} from "@spwn/types/firebase/firestore";

type TicketDoc = Ticket & Refference;
/**
 * チケットの閲覧権限（渡されたticketIdsがすべて管理対象か）を判定
 */
export const useIsAdminTickets = () => {
  const userId = useSelector((state) => state.auth.user.uid);
  const [isTicketAdmin, setIsTicketAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  //チケットidをクエリから取得する
  const { search } = useLocation();
  const ticketIds = useMemo(() => {
    const params = new URLSearchParams(search);
    const ticketIds = params.getAll("ticket_id");
    return ticketIds;
  }, [search]);

  useEffect(() => {
    if (!userId || ticketIds.length === 0) {
      setIsTicketAdmin(false);
      setLoading(false);
      return;
    }

    const fetchAdminData = async () => {
      setLoading(true);
      try {
        // TODO: この実装だとticketがあれば権限に関係なくこのページを見れるが, UIの作成を優先して一旦保留
        const adminDoc = await fetchFirestoreDocument<AdminDoc>(
          `/admins/${userId}`
        );
        const adminEventIds = adminDoc?.eventIds ?? [];
        if (!adminEventIds || adminEventIds.length === 0) {
          setIsTicketAdmin(false);
          return;
        }

        const allManagedTicketIds = (
          await Promise.all(
            adminEventIds.map(async (eventId) => {
              const tickets = await fetchFirestoreCollection<TicketDoc>(
                `/tickets/${eventId}/tickets`
              );
              return tickets.flatMap((t) => {
                return t._id ? [t._id] : [];
              });
            })
          )
        ).flat();
        const managedTicketIdsSet = new Set(allManagedTicketIds);
        const hasPermission = ticketIds.every((id) =>
          managedTicketIdsSet.has(id)
        );

        setIsTicketAdmin(hasPermission);
      } catch (error) {
        setIsTicketAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    void fetchAdminData();
  }, [userId, ticketIds]);
  return { isTicketAdmin, loading };
};
